import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-home-engineering-coding',
    templateUrl: './home-engineering-coding.component.html',
    styleUrls: ['./home-engineering-coding.component.css'],
})
export class HomeEngineeringCodingComponent implements OnInit {
    constructor() {}

    ngOnInit() {}
}



// WEBPACK FOOTER //
// /Users/masonpimentel/Repos/mason-blog/src/app/home-engineering-coding/home-engineering-coding.component.ts